import React from 'react'
import ReadMoreButton from '../../../read-more-button'
import { YoutubeMonitor } from '../../../youtube-monitor'

export const AboutSection = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="row content">
          <div className="col-lg-6">
            <h2>Laboratory and Plant Integration</h2>

            <h3>Easy tests results integration and association to milk pickups from Lab to Plant.</h3>

            <ReadMoreButton url="/docs/posts/getting-started-with-lab" />
          </div>
          <div className="col-lg-6 pt-4 pt-lg-0">
            <YoutubeMonitor youtubeId="oYv4Gzjbulw" />
          </div>
        </div>
      </div>
    </section>
  )
}
